import React, { forwardRef } from 'react'
import cn from '../../utils/cn'

const InputField = forwardRef(({ name, className, lableClassName, label, errorState, required, ...props }, ref) => {
  return (
    <div>
      <label
        htmlFor={name}
        className={cn("block text-md font-bold leading-5 text-black", lableClassName)}
      >
        {label}
        {required && <span className="text-accent-red" aria-hidden="true"> *</span>}
      </label>
      <div className="mt-1 relative rounded-md shadow-sm">
        <input
          {...props}
          name={name}
          required={required}
          ref={ref}
          className={
            cn(
              "appearance-none block w-full max-sm:px-3 p-4 border border-accent-gray-border rounded-md bg-white text-black placeholder-[#585858] focus:outline-none focus:shadow-outline-blue focus:border-accent-blue transition duration-150 ease-in-out text-md font-medium",
              className,
            )}
        />
      </div>
      {errorState && (
        <p className="text-accent-red text-sm mt-1">{errorState}</p>
      )}
    </div>
  )
})

export default InputField
